import { ReactNode } from 'react';
import Card from '@mui/material/Card';
import { useCard } from '../../lib/context';

export const CardCard = ({ children }: { children: ReactNode }) => {
  const { externalStyles, fullHeight } = useCard();

  const mergedStyles = {
    card: {
      ...externalStyles?.card,
      ...(fullHeight ? { height: '100%' } : {}),
    },
  };

  return <Card style={mergedStyles.card}>{children}</Card>;
};
